import React, { useMemo } from 'react';
import { SPORT_IDS_WITH_SPECIAL_SCORE_DISPLAY } from 'shared/constants/common';
import { getLiveEventTimeString } from 'shared/util/getLiveEventTime';
import { matchResult } from 'shared/util/utility';
import './styles.scss';

interface Props {
	className?: string;
	event: any;
}

const LiveScore: React.FC<Props> = ({ event }) => {
	const { infos, partialScores, score, result, sportId } = event;

	const isSpecialSportId = SPORT_IDS_WITH_SPECIAL_SCORE_DISPLAY.includes(sportId);

	const getLatestScore = (score: string) => (score ? score.split(' - ').pop() || '' : '');

	const liveEventTimeString = useMemo(() => getLiveEventTimeString(event.sportId, event.time), [event.sportId, event.time]);

	return (
		<div className="liveScore">
			<div className="liveScore__score">{isSpecialSportId ? matchResult(result) : score}</div>
			<div className="liveScore__progress">
				{isSpecialSportId ? getLatestScore(partialScores) : infos} {liveEventTimeString}
				{isSpecialSportId && `(${score})`}
			</div>
		</div>
	);
};

export default LiveScore;
